const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 }

export default BREAKPOINTS
